<script lang="ts">
	import { onMount } from 'svelte';
	import { FeatureFlags } from '#lib/constants/feature-flags.js';
	import { EditionsGallery } from '#lib/websites/editions/components/EditionsGallery/index.js';
	import { seriesGallerySort } from '#lib/websites/editions/constants/sorting.js';
	import type { EditionsGalleryCardEdition } from '#lib/websites/editions/utils/getEditionsGalleryCard/getEditionsGalleryCard.js';
	import { page } from '$app/state';
	import { getPageData } from '$global/utils/getPageData/getPageData';
	import type { SeriesPageData } from '$routes/editions/series/[slug]/types';

	// The count comes in as a prop rather than off the query: the REST and
	// GraphQL pages carry it under different names, and the branch that knows
	// which is in play is the page component.
	interface Props {
		query: {
			isFetching: boolean;
			isFetchingNextPage: boolean;
			fetchNextPage: () => void;
		};
		editions: EditionsGalleryCardEdition[] | undefined;
		count: number;
	}

	let { query, editions, count }: Props = $props();

	const dataCy = 'series';

	let data = $derived(getPageData<SeriesPageData>(page.data));
	let filterSections = $derived(data.filterSections);

	let isReady = $state(false);

	onMount(() => {
		isReady = true;
	});

	let hasMore = $derived(count > (editions?.length || 0));
	let loading = $derived(
		(query.isFetching && !query.isFetchingNextPage) || !isReady
	);
	let loadingNextPage = $derived(query.isFetchingNextPage);

	const sortOptions = [seriesGallerySort];

	const handleLoadMore = () => {
		query.fetchNextPage();
	};
</script>

<EditionsGallery
	{dataCy}
	{editions}
	{filterSections}
	{sortOptions}
	{count}
	{loading}
	{loadingNextPage}
	onLoadMore={handleLoadMore}
	{hasMore}
	initialLoadMoreButton={FeatureFlags.loadButtonBeforeInfiniteScroll}
	trackPrefix="EDITIONS"
	listId="editions_series"
/>
